import PropTypes from 'prop-types';

import {Popover} from 'antd';

import {faQuestionCircle} from '@fortawesome/free-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import './InfoPopoverIcon.css';

function InfoPopoverIcon({content, title, placement, maxWidth}) {
  return (
    <Popover
      content={content}
      title={title}
      trigger={['click']}
      placement={placement}
      classNames={{root: 'InfoPopoverIconOverlay'}}
      styles={{root: {maxWidth: maxWidth || '400px'}}}
    >
      <FontAwesomeIcon
        tabIndex={0}
        icon={faQuestionCircle}
        aria-hidden={false}
        aria-label={'Info icon'}
        focusable={true}
        className="InfoPopoverIcon icon"
        onClick={(e) => {
          // prevents native <label> click-forwarding to the associated field
          e.preventDefault();
          e.stopPropagation();
        }}
      />
    </Popover>
  );
}

InfoPopoverIcon.propTypes = {
  content: PropTypes.node.isRequired,
  title: PropTypes.string,
  placement: PropTypes.string,
  maxWidth: PropTypes.string,
};

export default InfoPopoverIcon;
